import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { useApiClientContext } from '../../../../hooks/context'

interface GraphQLProviderProps {
  children: React.ReactNode
}

/**
 * GraphQL Provider that integrates Apollo client with the Horizon auth system.
 *
 * Automatically gets the GraphQL client from the API client context, making it
 * a zero-config provider.
 */
export const GraphQLProvider: React.FC<GraphQLProviderProps> = ({
  children,
}) => {
  const apiClient = useApiClientContext()

  if (apiClient) {
    const apolloClient = apiClient.graphQL.getClient()
    return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
  }

  throw new Error(
    'GraphQLProvider could not find an API client context. Make sure your component is wrapped with ApiClientProvider.',
  )
}

GraphQLProvider.displayName = 'GraphQLProvider'
